import { useMemo } from 'react'
import { useAppStore } from '@core/store'
import { filtroDosPins, type PinFilter } from './lib/pinFilter'

/** O filtro dos pins, o mesmo para o overlay e para o painel: os filtros
 *  do painel (fechados e os critérios) e, com "Seguir
 *  os filtros do módulo BCF", o que a lista do módulo mostra (publicado
 *  em `bcfVistaDaLista`). */
export function usePinFiltro(): PinFilter {
  const hideClosed = useAppStore((s) => s.bcfPinsHideClosed)
  const seguirModulo = useAppStore((s) => s.bcfPinsSeguirModulo)
  const vista = useAppStore((s) => s.bcfVistaDaLista)
  const criterios = useAppStore((s) => s.bcfPinsCriterios)
  return useMemo(
    () => filtroDosPins({ hideClosed, seguirModulo, vista, criterios }),
    [hideClosed, seguirModulo, vista, criterios],
  )
}
